import React, {useState, useEffect} from 'react'
import { Form, InputGroup, Button, Row, Col, Modal, Spinner } from 'react-bootstrap'
import Select from 'react-select'
import { useTranslation } from 'react-i18next';
import { customerService, roleService, userService, licenseService } from '../../_services'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faKey, faTrash, faPlus, faCheck, faEnvelope } from '@fortawesome/free-solid-svg-icons'

const MultipleUserForm = () => {

	const initialState = {
		customer: 1,
		users: [
			{
				key: 0,
				parent: null,
				username: '',
				password: '',
				email: '',
				fullName: '',
				created: false
			}
		],
		enabled: true,
		accountExpired: false,
		accountLocked: false,
		passwordExpired: false,
		twoFactorAuthenticationType: 'NONE',
		userRoles: [],
		userLicenses: []
    }

	const [show, setShow] = useState(false)
	const [state, setState] = useState(initialState)
    const [customers, setCustomers] = useState([])
    const [userLicenses, setUserLicenses] = useState([])
    const [userRoles, setUserRoles] = useState([])
    const [users, setUsers] = useState([])
    const [validated, setValidated] = useState(false)
    const [stage, setStage] = useState("FORM")
    const {t} = useTranslation('common')

    useEffect(() => {
        customerService.getOptions().then(customers => {
            customers.sort((a, b) => a.name.localeCompare(b.name))
            setCustomers(customers)
        })
        licenseService.simpleList().then(licenses => {
            var userLicenses = []
            licenses.forEach(license => {
				var userLicense = {
					license: license.id,
					name: license.name,
					licenseCode: license.licenseCode,
					customerId: license.customerId
				}
                userLicenses.push(userLicense)
            })
            setUserLicenses(userLicenses)
        })
        roleService.list().then(roles => {
            var userRoles = roles.map(role => {
                return {'user': -1, 'role': role.id, 'roleAuthority': role.authority}
            })
            setUserRoles(userRoles)
        })
        userService.list().then(users => {
            users.sort((a, b) => a.username.localeCompare(b.username))
            setUsers(users)
        })
    }, [])

    const onClick = e => {
        setState(initialState)
        setValidated(false)
        setStage("FORM")

        setShow(true)
    }

    const onHide = e => {
        setShow(false)
    }

    const addUser = () => {
        var key = Math.max(...state.users.map(user => user.key)) + 1
        var newUsers = state.users.filter(user => true)
        newUsers.push({
                key: key,
				parent: '',
				username: '',
				password: '',
				email: '',
				fullName: '',
				created: false
		})
        handleChange({target: {type: "object", name: "users", value: newUsers}})
    }

    const removeUser = (user) => {
        var newUsers = state.users.filter(otherUser => otherUser != user)
        handleChange({target: {type: "object", name: "users", value: newUsers}})
    }

    const handleChange = (e) => {
	    const target = e.target
	    const name = target.name
	    const value = target.type === 'checkbox' ? target.checked : target.value;
	    setState( prevState => ({
	        ...prevState,
	        [name]: value
	    }));
	}

	const handleUserChange = (e, user) => {
	    const target = e.target
	    const name = target.name
	    const value = target.type === 'checkbox' ? target.checked : target.value
	    user[name] = value
	    var newUsers = state.users.filter(user => true)
        handleChange({target: {type: "object", name: "users", value: newUsers}})
	}

	const onCustomerChange = (e) => {
        console.log(e)
        handleChange({target: {type: "select", name: "customer", value: e.id}})
    }

    const onRoleChange = (e) => {
        handleChange({target: {type: "select", name: "userRoles", value: e || []}})
    }

    const onUserChange = (user) => {
        if (user) {
            var newSelectedValues = []
            user.userRoles.forEach(userRole => {
                newSelectedValues.push({user: -1, role: userRole.role, roleAuthority: userRole.roleAuthority})
            })
            handleChange({target: {type: "select", name: "userRoles", value: newSelectedValues}})
        }
    }

    const onUserLicenseChange = (e) => {
        handleChange({target: {type: "select", name: "userLicenses", value: e || []}})
    }

    const generatePassword = (user) => {
        let validChars = "ABCDEFGHJKLMNPQRSTUVXYZabcdefghijkmnopqrstuvxyz23456789"
        var newPassword = ""
        for (var i = 0; i < 12; i++) {
            let index = Math.floor(Math.random() * validChars.length)
            newPassword += validChars.charAt(index)
        }
        user.password = newPassword
        var newUsers = state.users.filter(user => true)
        handleChange({target: {type: "object", name: "users", value: newUsers}})
    }

    const filterUserLicenses = () => {
		return userLicenses.filter(userLicense => userLicense.customerId == state.customer)
    }

    const handleSubmit = (event) => {
	    event.preventDefault()
	    const form = event.currentTarget
	    if (form.checkValidity() === false) {
	        event.stopPropagation()
	        setValidated(true)
	    } else {
	        handleConfirm(state)
	        setValidated(false)
	    }
	}

    const handleConfirm = () => {
        console.log('handleConfirm')

        setStage("CREATING")

        state.users.forEach(user => {
            var data = {
                customer: state.customer,
                parent: user.parent,
				username: user.username,
				password: user.password,
				email: user.email,
				fullName: user.fullName,
				enabled: state.enabled,
				accountExpired: state.accountExpired,
				accountLocked: state.accountLocked,
				passwordExpired: state.passwordExpired,
				twoFactorAuthenticationType: state.twoFactorAuthenticationType,
				userRoles: state.userRoles,
				userLicenses: state.userLicenses
            }
            userService.save(data).then(response => {
                console.log(response)
                user.created = true

                var newUsers = state.users.filter(user => true)
                handleChange({target: {type: "object", name: "users", value: newUsers}})
            })
        })
    }

    const finish = () => {
        window.location.reload()
    }

    const getMailTo = (user, language) => {
        var firstName = ""
        if (user.fullName) {
            firstName = " " + user.fullName.split(" ")[0]
        }
        if (language == "SV") {
            return "mailto:" + user.email + "?subject=Telcodox användaruppgifter&body=" + "Hej" + firstName + "," + "%0D%0A" +
				"%0D%0A" +
				"Vi har skapat ett konto till dig på https://telcodox.iqmtel.net/" + "%0D%0A" +
				"Användarnamn: " + user.username + "%0D%0A" +
				"Lösenord: " + user.password + "%0D%0A" +
				"%0D%0A" +
				"Mvh Kristofer" + "%0D%0A" +
				"IQMTEL Sweden AB"
        }
        return "mailto:" + user.email + "?subject=Telcodox account info&body=" + "Hi" + firstName + "," + "%0D%0A" +
			"%0D%0A" +
			"We have created an account for you at https://telcodox.iqmtel.net/" + "%0D%0A" +
			"Username: " + user.username + "%0D%0A" +
			"Password: " + user.password + "%0D%0A" +
			"%0D%0A" +
			"Regards," + "%0D%0A" +
			"Kristofer" + "%0D%0A" +
			"IQMTEL Sweden AB"
    }

    return (
        <>
            <Button title="Skapa flera" variant="outline-secondary" onClick={onClick} style={{float: 'right', marginRight: 2}}>
				Skapa flera <FontAwesomeIcon icon={faPlus}/>
			</Button>
			<Modal
				style={{overflow: 'scroll'}}
				size={stage == "FORM" ? "xl" : "lg"}
				show={show}
				backdrop={true}
				onShow={() => console.log('onShow')}
				onHide={onHide}
				animation={false}>
				<Modal.Header closeButton>
					<Modal.Title>
						Skapa flera användare
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{ stage == "FORM" &&
				        <Form id="data-form" noValidate onSubmit={handleSubmit} validated={validated}>
				            <Row>
				                <Col sm="4">
				                    <Form.Group controlId="customer">
						                <Form.Label>
						                    {t('user.columns.customer')} *
						                </Form.Label>
						                <Select
						                    placeholder={t('user.columns.customer')}
						                    isLoading={customers.length === 0}
						                    options={customers}
						                    value={customers.find(customer => customer.id === state.customer)}
						                    getOptionLabel={customer => customer.name}
						                    getOptionValue={customer => customer.id}
						                    onChange={onCustomerChange}
						                />
						            </Form.Group>
						        </Col>
						        <Col sm="4">
							        <Form.Group controlId="roles">
						                <Form.Label>
						                    {t('user.columns.roles')}
						                </Form.Label>
						                <Select
						                    placeholder={t('user.select.placeholder')}
						                    isLoading={userRoles.length === 0}
						                    options={userRoles}
						                    value={state.userRoles}
						                    getOptionLabel={userRole => userRole.roleAuthority}
						                    getOptionValue={userRole => userRole.role}
						                    isMulti={true}
						                    closeMenuOnSelect={false}
						                    onChange={onRoleChange}
						                />
						            </Form.Group>
						            <Form.Group controlId="copyFrom">
					                    <Form.Label>
						                    {t('user.copyrolesfrom')}
						                </Form.Label>
						                <Select
						                    placeholder={t('user.chooseuser')}
						                    options={users}
						                    value={[]}
						                    getOptionLabel={user => user.username + ' (' + user.customerName + ')'}
						                    getOptionValue={user => user.id}
						                    isMulti={false}
						                    closeMenuOnSelect={true}
						                    onChange={onUserChange}
						                />
					                </Form.Group>
					            </Col>
					            <Col sm="4">
									<Form.Group controlId="userLicenses">
						                <Form.Label>
						                    {t('user.columns.licenses')}
						                </Form.Label>
						                <Select
						                    placeholder={t('user.columns.licenses')}
						                    isLoading={userLicenses.length === 0}
						                    options={filterUserLicenses()}
						                    value={state.userLicenses}
						                    getOptionLabel={userLicense => userLicense.name || userLicense.licenseCode}
						                    getOptionValue={userLicense => userLicense.license}
						                    isMulti={true}
						                    closeMenuOnSelect={false}
						                    onChange={onUserLicenseChange}
						                />
						            </Form.Group>
					            </Col>
				            </Row>
				            <Row>
				                <Col>
				                    <table className="table table-bordered">
				                        <thead>
				                            <tr>
				                                <th style={{ width: '30%' }}>
				                                    {t('user.columns.username')} *
				                                </th>
				                                <th>
				                                    {t('user.columns.password')} *
				                                </th>
				                                <th style={{ width: '30%' }}>
				                                    {t('user.columns.email')}
				                                </th>
				                                <th>
				                                    {t('user.columns.fullname')}
				                                </th>
				                                <th></th>
				                            </tr>
				                        </thead>
				                        <tbody>
				                            { state.users.map(user => {
					                            return <tr key={user.key}>
					                                <td style={{ padding: 5 }}>
					                                    <Form.Control
					                                        required
					                                        type="text"
					                                        placeholder={t('user.columns.username')}
					                                        name="username"
					                                        value={user.username}
					                                        onChange={e => handleUserChange(e, user)}
					                                    />
					                                </td>
					                                <td style={{ padding: 5 }}>
										                <InputGroup>
											                <Form.Control
											                    required
											                    type="input"
											                    placeholder={t('user.columns.password')}
											                    name="password"
											                    value={user.password}
											                    onChange={e => handleUserChange(e, user)}
											                    autoComplete="new-password"
											                />
											                <Button
											                    variant="outline-primary"
											                    onClick={e => generatePassword(user)}
											                >
											                    <FontAwesomeIcon icon={faKey}/>
											                </Button>
										                </InputGroup>
					                                </td>
					                                <td style={{ padding: 5 }}>
					                                    <Form.Control
					                                        type="email"
					                                        placeholder={t('user.columns.email')}
					                                        name="email"
					                                        value={user.email || ''}
					                                        onChange={e => handleUserChange(e, user)}
					                                    />
					                                </td>
					                                <td style={{ padding: 5 }}>
					                                    <Form.Control
					                                        type="input"
					                                        placeholder={t('user.columns.fullname')}
					                                        name="fullName"
					                                        value={user.fullName || ''}
					                                        onChange={e => handleUserChange(e, user)}
					                                    />
					                                </td>
					                                <td style={{ padding: 5 }}>
					                                    <Button
					                                        title="Ta bort"
					                                        variant="outline-danger"
					                                        size="sm"
					                                        onClick={e => removeUser(user)}
					                                    >
															<FontAwesomeIcon icon={faTrash}/>
														</Button>
					                                </td>
					                            </tr>
				                            })}
				                        </tbody>
				                    </table>
				                    <Button variant="outline-secondary" onClick={addUser}>
										Lägg till användare <FontAwesomeIcon icon={faPlus}/>
									</Button>
				                </Col>
				            </Row>
				        </Form>
			        }
			        { stage == "CREATING" &&
						<table className="table">
							<thead>
								<tr>
									<th>
										Användare
									</th>
									<th>
										Status
									</th>
									<th>
										SV
									</th>
									<th>
										EN
									</th>
								</tr>
							</thead>
							<tbody>
								{ state.users.map(user => {
									return <tr key={user.username}>
										<td>
											{ user.username }
										</td>
										<td style={{width: 50}}>
											{ !user.created &&
												<Spinner animation="border" role="status" size="sm">
													<span className="sr-only">Loading...</span>
												</Spinner>
											}
											{ user.created &&
												<FontAwesomeIcon icon={faCheck} style={{color: '#1f6e43'}}/>
											}
										</td>
										<td>
											{ !user.created &&
												<Spinner animation="border" role="status" size="sm">
													<span className="sr-only">Loading...</span>
												</Spinner>
											}
											{ user.created &&
												<a href={getMailTo(user, "SV")}>
													<FontAwesomeIcon icon={faEnvelope}/>
												</a>
											}
										</td>
										<td>
											{ !user.created &&
												<Spinner animation="border" role="status" size="sm">
													<span className="sr-only">Loading...</span>
												</Spinner>
											}
											{ user.created &&
												<a href={getMailTo(user, "EN")}>
													<FontAwesomeIcon icon={faEnvelope}/>
												</a>
											}
										</td>
									</tr>
								})}
							</tbody>
						</table>
			        }
				</Modal.Body>
				<Modal.Footer>
					{ stage == "FORM" &&
						<>
							<Button variant="secondary" onClick={onHide} disabled={stage == "CREATING"}>
								{t('crudtable.cancel')}
							</Button>
							<Button
								form="data-form"
								variant="primary"
								type="submit"
							>
								{t('crudtable.ok')}
							</Button>
						</>
					}
					{ stage == "CREATING" &&
						<Button
							variant="primary"
							type="submit"
							disabled={state.users.some(user => !user.created)}
							onClick={finish}
						>
							{t('crudtable.ok')}
						</Button>
					}
				</Modal.Footer>
			</Modal>
        </>
    )
}


export default MultipleUserForm